type CheckIconProps = {
  size?: number
}

export function CheckIcon({ size = 24 }: CheckIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M16.8372 4.47038C17.1301 4.17766 17.6049 4.17754 17.8977 4.47038C18.1902 4.76324 18.1903 5.23814 17.8977 5.53092L7.89772 15.5309C7.60493 15.8235 7.13002 15.8234 6.83717 15.5309L2.10182 10.7956C1.80918 10.5027 1.80922 10.0279 2.10182 9.73503C2.39467 9.44236 2.86952 9.44236 3.16237 9.73503L7.36745 13.9401L16.8372 4.47038Z" fill="currentColor" />
    </svg>
  )
}
